import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const DataDisplay = styled('div')`
  width: 350px;
  position: absolute !important;
  top: 20px;
  right: 60px;
  display: ${($open) => ($open ? 'flex' : 'none')};
`;

export const HeaderStack = styled(Stack)`
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TitleStack = styled(Stack)`
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

export const DataStack = styled(Stack)`
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
`;
